import type { RootState } from '../store';
import type { Documentation } from '../common/types/documentation';

const getDocumentation = (state: RootState): Documentation[] => state.documentation.documentation;

const getStatus = (state: RootState) => state.documentation.status;

const documentationSelector = {
  getDocumentation,
  getStatus,
};

export default documentationSelector;
